export function initProductAnimationBanner() {
    if (!document.querySelector('.animation-banner')) return;
        const banner = document.querySelector('.animation-banner');
        const media = banner.querySelector('.animation-banner__media');
        const heading = banner.querySelector('.animation-banner__heading');
        const product = banner.querySelector('.animation-banner__product img');
        const lists = banner.querySelector('.animation-banner__lists');
        const items = [...lists.querySelectorAll('li')];

        // Posisi tetap tiap item (left/top terhadap .animation-banner__media),
        // dipetakan berdasarkan urutan item (index), bukan teks label.
        // Urutan: Whey Protein, Kafein, Sumber Protein, Sumber Serat, Vitamin B1 & B3.
        const fixedPositions = [
            { left: 71.6, top: 63.67 },
            { left: 730, top: 27 },
            { left: -147.26, top: 311.97 },
            { left: 333.1, top: 385.51 },
            { left: 627.32, top: 315.19 }
        ];

        // Lebar .animation-banner__media saat posisi di atas dibuat (viewport >= 1366).
        const REF_WIDTH = 821;

        // Posisi mobile, dibuat saat lebar media 374px (viewport 414px - padding container 40px).
        const MOBILE_REF_WIDTH = 374;
        const mobilePositions = [
            { left: -12.25, top: 78 },
            { left: 240.75, top: 20 },
            { left: -6.5, top: 302 },
            { left: 130, top: 340 },
            { left: 187, top: 245 }
        ];

        const VIEWPORT_GAP = 8;

        const getScale = (isMobile) => isMobile
            ? media.clientWidth / MOBILE_REF_WIDTH
            : Math.min(1, media.clientWidth / REF_WIDTH);

        const getPosition = (item, position, scale) => {
            const left = position.left * scale;
            const top = position.top * scale;

            // Jaga item tetap di dalam viewport.
            const mediaRect = media.getBoundingClientRect();
            const minLeft = VIEWPORT_GAP - mediaRect.left;
            const maxLeft = document.documentElement.clientWidth - VIEWPORT_GAP - mediaRect.left - item.offsetWidth;

            return {
                left: Math.max(minLeft, Math.min(left, maxLeft)),
                top
            };
        };

        const applyPosition = (item, position) => {
            item.style.left = `${position.left}px`;
            item.style.top = `${position.top}px`;

            const centerX = media.clientWidth / 2;
            const centerY = media.clientHeight / 2;
            const itemCenterX = item.offsetWidth / 2;
            const itemCenterY = item.offsetHeight / 2;

            const fromX =
                centerX -
                itemCenterX -
                position.left;

            const fromY =
                centerY -
                itemCenterY -
                position.top;

            item.style.setProperty('--from-x', `${fromX}px`);
            item.style.setProperty('--from-y', `${fromY}px`);
        };

        const placeItems = () => {
            const isMobile = window.matchMedia('(max-width: 767.98px)').matches;

            const scale = getScale(isMobile);

            items.forEach(item => {
                const label = item.querySelector('.elm-best');
                if (isMobile) {
                    label.style.fontSize = `${Math.max(9, 11 * scale)}px`;
                    label.style.padding = `${Math.max(6, 8 * scale)}px ${Math.max(10, 14 * scale)}px`;
                } else if (scale < 1) {
                    // Tablet: perkecil label & posisi proporsional terhadap lebar media.
                    label.style.fontSize = `${Math.max(11, 20 * scale)}px`;
                    label.style.padding = `${Math.max(8, 20 * scale)}px ${Math.max(14, 40 * scale)}px`;
                } else {
                    label.style.fontSize = '';
                    label.style.padding = '';
                }
            });

            if (isMobile) {
                    items.forEach((item, index) => {
                    applyPosition(item, getPosition(item, mobilePositions[index % mobilePositions.length], scale));
                });
                return;
            }

            items.forEach((item, index) => {
                applyPosition(item, getPosition(item, fixedPositions[index % fixedPositions.length], scale));
            });
        };

        const activate = () => {
            placeItems();

            requestAnimationFrame(() => {
                heading.classList.add('active');
                product.classList.add('active');
                lists.classList.add('active');
            });
        };

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    activate();
                    observer.unobserve(banner);
                }
            });
        }, {
            threshold: 0.60
        });

        placeItems();
        observer.observe(banner);

        window.addEventListener('resize', () => {
            placeItems();
        });
}
